import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';

const Area = () => {
  const { t } = useTranslation('app');
  const {
    setValue: setValueForm,
    watch,
    formState: { errors },
    clearErrors,
  } = useFormContext();

  const isError = errors.area;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearErrors('area');
    const num = Number(e.target.value);
    if (!isNaN(num)) setValueForm('area', num);
  };

  return (
    <div className="flex flex-col gap-2x flex-1">
      <p className="text-title_4 text-black">{t('propertyArea')}</p>
      <div className="flex flex-col gap-3">
        <div
          className={`${isError ? 'border-red_dark' : ''} flex gap-1.5x rounded-[12px] border border-[#E0E0E0] h-[40px] px-1.5x py-x focus-within:border-blue_light_1 transition-all`}
        >
          <input
            type="text"
            placeholder={t('propertyAreaPlaceholder')}
            value={watch('area') || ''}
            onChange={handleChange}
            className="text-body_2 text-gray__dark_2 placeholder:text-gray__dark_1 flex-1 w-[60px]"
          />
          <p className="h-[24px] ps-x border-s border-gray text-body_2 text-gray__dark_2">
            {t('m2')}
          </p>
        </div>
        {isError && <p className="text-red_dark">{t('areaRequired')}</p>}
      </div>
    </div>
  );
};

export default Area;
